import { validateArguments } from '../../SignatureValidation';
export var ReplaceFn;
(function (ReplaceFn) {
    ReplaceFn.Name = `REPLACE`;
    ReplaceFn.Stage = "SCALAR";
    ReplaceFn.Signature = `REPLACE(<string>, <searchString>, <replaceString>)`;
    function make(callName, args, type, role) {
        return {
            name: ReplaceFn.Name,
            stage: ReplaceFn.Stage,
            data: { role, type },
            value: (...values) => {
                if (values.length !== 3) {
                    throw new Error(`REPLACE function expects 3 arguments ` +
                        `but received ${values.length}`);
                }
                const [value, searchValues, replaceValue] = values;
                if (value == null || searchValues == null || replaceValue == null) {
                    return null;
                }
                if (typeof value === 'string' &&
                    typeof searchValues === 'string' &&
                    typeof replaceValue === 'string') {
                    return value.replaceAll(searchValues, replaceValue);
                }
                throw new Error(`Invalid input for REPLACE, expected inputs must be string`);
            },
        };
    }
    ReplaceFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            arguments: [
                "STRING",
                "STRING",
                "STRING",
            ],
            meta: {
                name: ReplaceFn.Name,
                signature: ReplaceFn.Signature,
                location: callNode.location,
            },
        }, args);
    }
    ReplaceFn.validate = validate;
})(ReplaceFn || (ReplaceFn = {}));
